import utilities from './utilities';

/**
 * Collapsible Blocks
 */
class Collapsible {
  constructor(el, options) {
    this.el = el;
    this.options = options;
    this.head = el.querySelector(this.options.selectors.head);
    this.intro =  el.querySelector(this.options.selectors.intro);
    this.body = el.querySelector(this.options.selectors.body);
    this.content = el.querySelector(this.options.selectors.content);
    this.baseHeight = this.content.offsetHeight + 'px';

    if ( this.intro ) {
      this.introHeight = ( this.intro.offsetHeight + 15 ) + 'px';
    }

    this.bind();
    if ( ! el.classList.contains('is-open') )
      this.close();
  }

  bind() {
    this.head.addEventListener('click', e => this.toggle(e));
    let resize = utilities.debounce(e => this.resize(e), 300);
    window.addEventListener('resize', resize);
  }

  toggle() {
    this.el.classList.contains('is-open') ? this.close() : this.open();
    this.el.classList.toggle('is-open');
  }

  open() {
    this.body.style.height = this.baseHeight;
    if ( this.intro ) {
      this.intro.style.height = this.introHeight;
    }
  }

  close() {
    this.baseHeight = this.content.offsetHeight + 'px';
    this.body.style.height = 0;
    if ( this.intro ) {
      this.intro.style.height = 0;
    }
  }

  resize(e) {
    this.baseHeight = this.content.offsetHeight + 'px';
    if ( this.el.classList.contains('is-open') ) {
      this.body.style.height = this.baseHeight;
      this.intro.style.height = 'auto';
      this.intro.style.height = ( this.intro.offsetHeight + 15 ) + 'px';
    }
  }
}

export default Collapsible;



// WEBPACK FOOTER //
// ./scripts/components/collapse.js